import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import Section from '../../molecules/Section'
import * as styles from './EmbededReviews.module.css'

const query = graphql`
  query PageEmbededReviewsQuery {
    embededReviews: allFile(
      filter: { relativePath: { eq: "pages/templates/embededReviews.json" } }
    ) {
      edges {
        node {
          childTemplatesJson {
            title
            description
            reviews
          }
        }
      }
    }
  }
`

export default function EmbededReviews() {
  const data = useStaticQuery(query)
  const { title, description, reviews } =
    data.embededReviews.edges[0].node.childTemplatesJson

  return (
    <Section
      id="templates"
      title={title}
      description={description}
      className={styles.section}
    >
      <div className={styles.container}>
        <iframe
          className={styles.reviews}
          src={reviews}
          allowFullScreen
        ></iframe>
      </div>
    </Section>
  )
}
